import { Button } from "@fluentui/react-components";
import { ArrowSyncRegular } from "@fluentui/react-icons";
import React, { useContext } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";

export const ApplyButton = () => {
  const { onClickApply, strings, id } = useContext(ColumnOptionsContext);

  return (
    <Button
      appearance="primary"
      id={id ? `${id}-btn-apply` : undefined}
      data-testid="column-options-apply"
      icon={<ArrowSyncRegular />}
      onClick={onClickApply}
    >
      {strings.applyButtonLabel}
    </Button>
  );
};
